module.exports = __webpack_public_path__ + "static/fonts/lynkcotype-bold.0cf8c49d.otf";